import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.334 12.667A.667.667 0 0 0 14 12V4a.666.666 0 0 0-.666-.666H2.667A.667.667 0 0 0 2 4v8c0 .368.298.667.667.667zM2.667 14a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10.667a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m8.666 10.666.135.014a.667.667 0 0 1 0 1.307L8.666 12H7.333a.667.667 0 0 1 0-1.334z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })